import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

const ADMIN_KEY = "bq_admin_token";
const REPORTS_KEY = "bq_reports_token";

// Admin JWT is stored in sessionStorage (tab-scoped, cleared on tab close) rather
// than localStorage to narrow XSS exposure of the privileged credential.
export const getAdminToken = () => {
  try {
    return sessionStorage.getItem(ADMIN_KEY);
  } catch {
    return null;
  }
};

export const setAdminToken = (token) => {
  try {
    if (token) {
      sessionStorage.setItem(ADMIN_KEY, token);
      api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    } else {
      sessionStorage.removeItem(ADMIN_KEY);
      delete api.defaults.headers.common["Authorization"];
    }
  } catch {
    /* storage unavailable */
  }
  // Always drop any legacy localStorage copy.
  try {
    localStorage.removeItem(ADMIN_KEY);
  } catch {
    /* ignore */
  }
};

// Read-only reports-portal token (separate simple-password login). Tab-scoped.
export const getReportsToken = () => {
  try {
    return sessionStorage.getItem(REPORTS_KEY);
  } catch {
    return null;
  }
};

export const setReportsToken = (token) => {
  try {
    if (token) {
      sessionStorage.setItem(REPORTS_KEY, token);
      api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    } else {
      sessionStorage.removeItem(REPORTS_KEY);
      delete api.defaults.headers.common["Authorization"];
    }
  } catch {
    /* storage unavailable */
  }
};

// Boot-time: rehydrate the Bearer header from sessionStorage, migrating a legacy
// localStorage token once (then removing it) so existing admin sessions survive.
(function initAdminToken() {
  if (typeof window === "undefined") return;
  let token = null;
  try {
    token = sessionStorage.getItem(ADMIN_KEY);
  } catch {
    /* ignore */
  }
  if (!token) {
    try {
      const legacy = localStorage.getItem(ADMIN_KEY);
      if (legacy) {
        token = legacy;
        sessionStorage.setItem(ADMIN_KEY, legacy);
        localStorage.removeItem(ADMIN_KEY);
      }
    } catch {
      /* ignore */
    }
  }
  // Fall back to a reports-portal token when no admin token is present.
  if (!token) {
    try {
      token = sessionStorage.getItem(REPORTS_KEY);
    } catch {
      /* ignore */
    }
  }
  if (token) {
    api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  }
})();
